import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateFavouredInfodex} from '../containers/GroupedInfodex/actions';
const storageHandler = new StorageHandler();

function* getFavouredInfodex(action){

  const Network = new NetworkHandler();
  try{
      const response = yield Network.requestGetLinkedInfodexInfo(action.payload);

      if (!(response instanceof Error)) {
          yield put(
                updateFavouredInfodex(
                response
              )
            );
        } else {
          yield put(
            error({
              message: 'Unable to load Linked Infodex',
            })
          );
      }
  }catch (errorMsg) {
      yield put(
          error({
           message: `Unable to load Linked Infodex, please try again.${errorMsg}`,
          })
      );
  }
}

export default function* usersSagas() { 
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_FAVOURED_GET, getFavouredInfodex);
}